/*
 * ByLamari: Kategorieseite des übertragenen Hydrogen-Neubaus (routes/collection.tsx, Theme-Kopie B, 25.10.2026).
 *  - Farbwahl Gold/Bicolor/Silber im Browser (?farbe=): Stücke in der Farbe zuerst, mit Foto, Variante und
 *    Tragebild dieser Farbe; Blende beim Umsortieren (View Transitions, Stile in bl-n-kollektion-nachgeladen)
 *  - Geschenke: „Wonach suchst du?“ (?wunsch=)
 *  - Endlos-Scrollen in 24er-Schritten, Emotionsbilder und „Bestseller Kombis“ an fester Stelle
 *  - Auftritt der Kacheln beim Scrollen
 * Teil 2 (Leiste, Filter, Hinweisleiste): assets/bl-kollektion-2.js
 */
(function () {
  var wurzel = document.querySelector('[data-bl-koll]');
  var raster = document.getElementById('product-grid');
  if (!wurzel) return;
  var SCHRITT = 24, START_DAUER = 2600, STAFFEL = 80;
  var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nav = wurzel.querySelector('[data-bl-farbwahl]');
  var farben = nav ? Array.prototype.map.call(nav.querySelectorAll('[data-farbe]'), function (a) { return a.getAttribute('data-farbe'); }) : ['Gold'];
  var params = new URLSearchParams(location.search);
  var farbe = 'Gold', wunsch = null, anzahl = SCHRITT;
  var kinder = raster ? Array.prototype.slice.call(raster.children) : [];
  var produkte = kinder.filter(function (li) { return li.hasAttribute('data-bl-k'); });
  var extras = kinder.filter(function (li) { return li.hasAttribute('data-bl-platz'); });
  produkte.forEach(function (li) {
    li._k = JSON.parse(li.getAttribute('data-bl-k'));
    li._nr = parseInt(li.getAttribute('data-bl-nr'), 10);
  });

  function bildUrl(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&height=' + w + '&crop=center'; }
  function srcset(u, max) {
    var b = [240, 360, 480, 640, 720, 800, 1000, 1200, 1600], aus = [];
    for (var i = 0; i < b.length; i++) {
      if (max && b[i] > max && aus.length) break;
      aus.push(bildUrl(u, b[i]) + ' ' + b[i] + 'w');
      if (max && b[i] >= max) break;
    }
    return aus.join(', ');
  }
  function wunschPasst(li) {
    if (!wunsch) return true;
    var typ = li.getAttribute('data-bl-typ');
    if (wunsch === 'ringe') return typ === 'Ring';
    if (wunsch === 'ring_kette') return typ === 'Ring' || typ === 'Kette';
    return parseInt(li.getAttribute('data-bl-preis'), 10) < 2500;
  }

  /* Karte auf die Farbe einstellen (Foto, Plus-Variante, Wechselbild) */
  function karte(li, c) {
    var k = li._k, f = c.toLowerCase(), inFarbe = k.f.indexOf(f) > -1, x = k.x[f] || {};
    var b = inFarbe && x.b ? x.b : k.b;
    var v = inFarbe && x.v ? x.v : k.v;
    var h = f === 'gold' ? k.hg : (inFarbe ? x.h : null);
    var art = li.querySelector('.bl-product-card');
    var img = art.querySelector('.bl-product-card__media > img:not(.bl-product-card__hover)');
    if (img && b) {
      var neu = bildUrl(b[0], 480);
      if (img.getAttribute('src') !== neu) { img.src = neu; img.srcset = srcset(b[0], b[1]); img.alt = b[2]; }
    }
    var form = art.querySelector('[data-bl-schnellkauf]');
    if (form && v) {
      form.querySelector('[name="id"]').value = v[0];
      var fn = k.n > 1 && v[1] ? ' in ' + v[1] : '';
      form.querySelector('button').setAttribute('aria-label', k.t + fn + ' in den Warenkorb legen');
      form.setAttribute('data-meldung', k.t + fn + ' liegt im Warenkorb.');
    }
    var alt = art.querySelector('.bl-product-card__hover');
    if (alt) alt.remove();
    art.classList.remove('is-alt');
    var punkte = art.querySelector('.bl-product-card__punkte');
    if (h) {
      art.setAttribute('data-bl-hover-src', bildUrl(h[0], 480));
      art.setAttribute('data-bl-hover-srcset', srcset(h[0], h[1]));
      art.setAttribute('data-bl-wischen', '');
      art.classList.add('has-alt');
      if (!punkte) {
        punkte = document.createElement('span');
        punkte.className = 'bl-product-card__punkte';
        punkte.setAttribute('aria-hidden', 'true');
        punkte.innerHTML = '<i></i><i></i>';
        var badge = art.querySelector('.bl-product-card__media .bl-badge, .bl-product-card__media .bl-chip');
        art.querySelector('.bl-product-card__media').insertBefore(punkte, badge);
      }
    } else {
      art.removeAttribute('data-bl-hover-src');
      art.removeAttribute('data-bl-hover-srcset');
      art.removeAttribute('data-bl-wischen');
      art.classList.remove('has-alt');
      if (punkte) punkte.remove();
    }
  }

  /* Reihenfolge, Emotionsbilder, Kombis, Sichtbarkeit */
  function ordnen() {
    if (!raster) return;
    var f = farbe.toLowerCase();
    var vorne = [], hinten = [], weg = [];
    produkte.slice().sort(function (a, b) { return a._nr - b._nr; }).forEach(function (li) {
      if (!wunschPasst(li)) { weg.push(li); return; }
      var k = li._k;
      (k.f.indexOf(f) > -1 || (f === 'gold' && k.f.length === 0) ? vorne : hinten).push(li);
    });
    var sortiert = vorne.concat(hinten);
    var zeigen = Math.min(anzahl, sortiert.length);
    var frag = document.createDocumentFragment();
    var platziert = [];
    sortiert.forEach(function (li, i) {
      extras.forEach(function (x) {
        if (i === 0 || parseInt(x.getAttribute('data-bl-platz'), 10) !== i) return;
        var art = x.getAttribute('data-bl-art');
        var sp = art === 'm' ? 1 : art === 'd' ? 3 : 0;
        x.hidden = !(i < zeigen && zeigen - i >= sp * (parseInt(x.getAttribute('data-bl-reihen'), 10) || 0));
        frag.appendChild(x);
        platziert.push(x);
      });
      li.hidden = i >= zeigen;
      if (i < 8) li.style.setProperty('--bl-ki', i); else li.style.removeProperty('--bl-ki');
      frag.appendChild(li);
    });
    weg.forEach(function (li) { li.hidden = true; frag.appendChild(li); });
    extras.forEach(function (x) { if (platziert.indexOf(x) < 0) { x.hidden = true; frag.appendChild(x); } });
    raster.appendChild(frag);
    var ende = wurzel.querySelector('[data-bl-ende]');
    if (ende) ende.hidden = zeigen >= sortiert.length;
    zaehlen(sortiert);
  }

  function zaehlen(sortiert) {
    var f = farbe.toLowerCase(), gesamt = sortiert.length, inF = 0, unbekannt = false;
    sortiert.forEach(function (li) { if (li._k.f.indexOf(f) > -1) inF++; if (!li._k.f.length) unbekannt = true; });
    var p = gesamt + ' ' + (gesamt === 1 ? 'Produkt' : 'Produkte');
    var text = f === 'gold' && unbekannt ? p : inF + ' in ' + farbe + ' · ' + p;
    document.querySelectorAll('[data-bl-anzahl-text]').forEach(function (e) { e.textContent = text; });
    var knopf = document.querySelector('[data-bl-ansehen-text]');
    if (knopf) knopf.textContent = gesamt === 1 ? '1 Produkt ansehen' : gesamt + ' Produkte ansehen';
  }

  function farbeSetzen(neu, animiert) {
    if (farben.indexOf(neu) < 0) neu = 'Gold';
    var vorher = farbe;
    farbe = neu;
    if (nav) {
      nav.setAttribute('data-farbe', neu.toLowerCase());
      nav.style.setProperty('--bl-fw-index', Math.max(0, farben.indexOf(neu)));
      nav.querySelectorAll('[data-farbe]').forEach(function (a) {
        if (a.getAttribute('data-farbe') === neu) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      if (animiert && vorher !== neu) {
        nav.setAttribute('data-gewechselt', '');
        var pill = nav.querySelector('.bl-farbwahl__pill');
        var g = pill.querySelector('.bl-farbwahl__glanz');
        if (g) g.remove();
        g = document.createElement('span');
        g.className = 'bl-farbwahl__glanz';
        pill.appendChild(g);
      }
    }
    var tun = function () {
      produkte.forEach(function (li) { karte(li, neu); });
      ordnen();
      if (window.BL && BL.stacksFarbe) BL.stacksFarbe(neu);
      auftrittPruefen(true);
    };
    if (animiert && raster) raster.setAttribute('data-farbwechsel', '');
    if (animiert && document.startViewTransition && !reduziert) document.startViewTransition(tun);
    else tun();
  }

  function adresse() {
    var p = new URLSearchParams(location.search);
    if (farbe === 'Gold') p.delete('farbe'); else p.set('farbe', farbe);
    if (wunsch) p.set('wunsch', wunsch); else p.delete('wunsch');
    var s = p.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : ''));
  }

  if (nav) nav.addEventListener('click', function (e) {
    var a = e.target.closest('[data-farbe]');
    if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    farbeSetzen(a.getAttribute('data-farbe'), true);
    adresse();
  });

  /* Geschenke: Wunsch-Kacheln */
  function wunschZeigen() {
    wurzel.querySelectorAll('[data-bl-wunsch]').forEach(function (a) {
      var an = a.getAttribute('data-bl-wunsch') === wunsch;
      a.classList.toggle('is-aktiv', an);
      if (an) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  wurzel.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bl-wunsch]');
    if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    var w = a.getAttribute('data-bl-wunsch');
    wunsch = wunsch === w ? null : w;
    anzahl = SCHRITT;
    ordnen();
    adresse();
    wunschZeigen();
    auftrittPruefen(true);
  });

  /* Endlos scrollen: je 24 weitere, sobald das Ende in Sicht kommt */
  var ende = wurzel.querySelector('[data-bl-ende]');
  if (ende && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      if (es.some(function (x) { return x.isIntersecting; }) && !ende.hidden) {
        anzahl += SCHRITT;
        ordnen();
        auftrittPruefen(false);
      }
    }, { rootMargin: '800px 0px' }).observe(ende);
  }

  /* Auftritt der Kacheln (bylamari-farbwahl.css Abschnitt 6, bylamari-kollektion-nachgeladen.css) */
  var beobachter = null, gesehen = new WeakSet(), erster = true;
  function auftrittPruefen(farbwechsel) {
    if (!raster || reduziert || !('IntersectionObserver' in window)) return;
    beobachter = beobachter || new IntersectionObserver(function (es) {
      var rein = es.filter(function (e) { return e.isIntersecting; }).sort(function (a, b) {
        return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left;
      });
      rein.forEach(function (e, i) {
        var li = e.target, verz = Math.min(i, 5) * STAFFEL;
        beobachter.unobserve(li);
        li.style.setProperty('--bl-ka-verz', verz + 'ms');
        li.dataset.auftritt = 'ein';
        setTimeout(function () { if (li.dataset.auftritt === 'ein') li.dataset.auftritt = 'da'; }, verz + 1600);
      });
      if (rein.length) raster.querySelectorAll(':scope > li[data-auftritt="wartet"]').forEach(function (li) {
        if (li.getBoundingClientRect().bottom <= 0) { beobachter.unobserve(li); li.dataset.auftritt = 'da'; }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    var hoehe = window.innerHeight;
    Array.prototype.forEach.call(raster.children, function (li) {
      if (li.hidden) return;
      var wartet = li.dataset.auftritt === 'wartet', neu = !gesehen.has(li);
      gesehen.add(li);
      if (!neu && !wartet) return;
      if (!neu && !farbwechsel) { beobachter.observe(li); return; }
      var r = li.getBoundingClientRect(), imBild = r.top < hoehe && r.bottom > 0;
      if (wartet) {
        if (imBild) { beobachter.unobserve(li); li.dataset.auftritt = 'da'; } else beobachter.observe(li);
      } else if (r.bottom <= 0 || (imBild && farbwechsel)) {
        li.dataset.auftritt = 'da';
      } else if (!imBild || !erster) {
        li.dataset.auftritt = 'wartet';
        beobachter.observe(li);
      }
    });
    erster = false;
  }

  /* Start: Farbe und Wunsch aus der Adresse, dann Auftritt */
  var w0 = params.get('wunsch');
  if (w0 === 'ringe' || w0 === 'unter25' || w0 === 'ring_kette') wunsch = w0;
  var f0 = (params.get('farbe') || '').toLowerCase();
  var start = farben.filter(function (f) { return f.toLowerCase() === f0; })[0];
  if (start && start !== 'Gold') farbeSetzen(start, false); else ordnen();
  if (wunsch) wunschZeigen();
  if (raster) setTimeout(function () { raster.removeAttribute('data-auftritt'); }, START_DAUER);
  auftrittPruefen(false);
})();